import React, { Component, createRef } from 'react';
import { CommonValidationMessages } from '../../utils/Messages.js';
import CommonServices from '../../services/axioServices/apiServices/CommonServices.js';
import SwalServices from '../../services/swalServices/SwalServices.js';
import { isValidForm } from '../../utils/validation/CommonValidator.js';
import SearchSection from '../../components/account/GSTSalesPurchaseRegister/SearchSection.js';
import TableSection from '../../components/account/GSTSalesPurchaseRegister/TableSection.js';
import LowerSection from '../../components/account/GSTSalesPurchaseRegister/LowerSection.js';
import { FinancealYearStartDateEndDate } from '../../utils/FinancialYearStartDateEndDate.js';
import AccountServices from '../../services/axioServices/apiServices/AccountServices.js';
import { getAuthProps } from '../../utils/AuthenticationLibrary.js';

class GstPurchaseRegister extends Component {
    constructor(props) {
        super(props);
        this.printRef = createRef();
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.accountServices = new AccountServices();
        this.state = {
            companyName: '',
            pageName: "gstPurchase",
            totalCount: 2,
            tableStatus: "",
            filterDetails: {
                startDate: "",
                endDate: "",
                allParty: true,
                partyId: "",
                invoiceType: "allinvoice",
                gstRate: "",
                search: "invoiceDetails",
                salesPurchaseAmount: "",
                discount: "",
                sgstAmt: "",
                cgstAmt: "",
                igstAmt: "",
                freight: "",
                other: "",
                roundOff: "",
                netAmount: "",
                taxableAmount: "",
                sgstAmount: "",
                cgstAmount: "",
                igstAmount: "",
                materialType: "",
            },
            gstSummaryList: [],
            gstPurchaseSummaryList: [],
            gstPurchaseRegisterList: [],
            invoiceTypeList: [
                { invoiceType: "All Invoice ", value: "allinvoice" },
                { invoiceType: "SGST", value: "sgst" },
                { invoiceType: "CGST", value: "cgst" },
                { invoiceType: "IGST", value: "igst" },
            ],
            materialTypeList: [
                { materialType: "All", value: "all" },
                { materialType: "Raw Material", value: "rawMaterial" },
                { materialType: "Packing Material", value: "packingMaterial" },
            ],
            searchList: [
                { search: "Invoice Details", value: "invoiceDetails" },
                { search: "Purchase Summary", value: "salesPurchseSummary" },
                { search: "GST Summary", value: "gstSummary" },
            ],
            partyDropdownList: [],
            validationRules: {
                startDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "start date"
                        ),
                    },
                ],
                endDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "end date"
                        ),
                    },
                ],
            },
            validState: {
                isValid: true,
                error: {},
            },

        };
    }

    componentDidMount() {
        let dates = FinancealYearStartDateEndDate()
        let filterDetails = this.state.filterDetails
        filterDetails.startDate = dates.startDate
        filterDetails.endDate = dates.endDate
        this.setState({ filterDetails: filterDetails })
        this.getAllGSTPurchaseRegister()
        const company = getAuthProps()
        this.setState({ companyName: company?.companyName })
    }

    getAllGSTPurchaseRegister = () => {
        let isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            this.setState({ tableStatus: "Loading..." }, () => {
                let request = this.state.filterDetails
                this.accountServices.getAllGSTPurchaseRegister(request).then((response) => {
                    if (response.statusCode === 200 && response.responseData != null) {
                        let res = response.responseData
                        res.map(details => {
                            details.sgstRate = (details.sgst / details.subTotal) * 100
                            details.cgstRate = (details.cgst / details.subTotal) * 100
                            details.igstRate = (details.igst / details.subTotal) * 100
                        })

                        const totalDisAmount = res.reduce((sum, item) => sum + (item.discount ? item.discount : 0), 0);
                        const totalSubTotalAmount = res.reduce((sum, item) => sum + (item.subTotal ? item.subTotal : 0), 0);
                        const totalSGSTAmtAmount = res.reduce((sum, item) => sum + (item.sgst ? item.sgst : 0), 0);
                        const totalCGSTAmtAmount = res.reduce((sum, item) => sum + (item.cgst ? item.cgst : 0), 0);
                        const totalIGSTAmount = res.reduce((sum, item) => sum + (item.igst ? item.igst : 0), 0);
                        const totalFreightAmount = res.reduce((sum, item) => sum + (item.freight ? item.freight : 0), 0);
                        const totalOtherAmount = res.reduce((sum, item) => sum + (item.other ? item.other : 0), 0);
                        const totalRoundOffAmount = res.reduce((sum, item) => sum + item.roundOff, 0);
                        const totalNetAmtAmount = res.reduce((sum, item) => sum + item.grandTotal, 0);

                        let details = this.state.filterDetails
                        details.discount = Number(totalDisAmount ? totalDisAmount : 0).toFixed(2)
                        details.sgstAmt = Number(totalSGSTAmtAmount).toFixed(2)
                        details.cgstAmt = Number(totalCGSTAmtAmount).toFixed(2)
                        details.igstAmt = Number(totalIGSTAmount).toFixed(2)
                        details.freight = Number(totalFreightAmount).toFixed(2)
                        details.other = Number(totalOtherAmount).toFixed(2)
                        details.roundOff = Number(totalRoundOffAmount).toFixed(2)
                        details.netAmount = Number(totalNetAmtAmount).toFixed(2)
                        details.salesPurchaseAmount = Number(totalSubTotalAmount - totalOtherAmount - totalFreightAmount).toFixed(2)
                        this.setState({ gstPurchaseRegisterList: res, filterDetails: details }, () => {
                            this.getAllPartyDropdown()
                            let taxSummary = { sgst: {}, cgst: {}, igst: {} };

                            res.forEach(item => {
                                let sgstRate = item.sgstRate.toFixed(2);
                                let cgstRate = item.cgstRate.toFixed(2);
                                let igstRate = item.igstRate.toFixed(2);

                                taxSummary.sgst[sgstRate] = (taxSummary.sgst[sgstRate] || 0) + item.sgst;
                                taxSummary.cgst[cgstRate] = (taxSummary.cgst[cgstRate] || 0) + item.cgst;
                                taxSummary.igst[igstRate] = (taxSummary.igst[igstRate] || 0) + item.igst;
                            });

                            // Convert tax summary to list format
                            let gstSummaryList = [
                                ...Object.keys(taxSummary.sgst).map(rate => ({
                                    des: `SGST ${rate}%`,
                                    amount: taxSummary.sgst[rate]
                                })),
                                ...Object.keys(taxSummary.cgst).map(rate => ({
                                    des: `CGST ${rate}%`,
                                    amount: taxSummary.cgst[rate]
                                })),
                                ...Object.keys(taxSummary.igst).map(rate => ({
                                    des: `IGST ${rate}%`,
                                    amount: taxSummary.igst[rate]
                                })),
                                { des: 'Freight', amount: details.freight },
                                { des: 'Other', amount: details.other },
                                { des: 'Round Off', amount: details.roundOff },
                                { des: 'Net Amount', amount: details.netAmount }
                            ];

                            let gstSummary = {};

                            res.forEach(item => {
                                let rate = (item.sgstRate || item.cgstRate || item.igstRate).toFixed(2); // Get tax rate

                                if (!gstSummary[rate]) {
                                    gstSummary[rate] = {
                                        rate: rate,
                                        taxableAmount: 0,
                                        sgstAmount: 0,
                                        cgstAmount: 0,
                                        igstAmount: 0
                                    };
                                }

                                gstSummary[rate].taxableAmount += item.subTotal;
                                gstSummary[rate].sgstAmount += item.sgst;
                                gstSummary[rate].cgstAmount += item.cgst;
                                gstSummary[rate].igstAmount += item.igst;
                            });

                            let gstSummary1List = Object.values(gstSummary);

                            let grandTotal = gstSummary1List.reduce((acc, curr) => {
                                acc.taxableAmount += curr.taxableAmount;
                                acc.sgstAmount += curr.sgstAmount;
                                acc.cgstAmount += curr.cgstAmount;
                                acc.igstAmount += curr.igstAmount;
                                return acc;
                            }, { taxableAmount: 0, sgstAmount: 0, cgstAmount: 0, igstAmount: 0 });

                            gstSummary1List.push(
                                // { rate: "TOTAL", ...grandTotal },
                                { rate: "GRANDTOTAL", ...grandTotal }
                            );
                            if (response.responseData.length === 0) {
                                this.setState({ tableStatus: "No Record Found" })
                            } else {
                                this.setState({ tableStatus: "" })
                            }

                            let filterDetails = this.state.filterDetails
                            filterDetails.taxableAmount = gstSummary1List.reduce((sum, item) => sum + item.taxableAmount, 0).toFixed(2);
                            filterDetails.sgstAmount = gstSummary1List.reduce((sum, item) => sum + item.sgstAmount, 0).toFixed(2);
                            filterDetails.cgstAmount = gstSummary1List.reduce((sum, item) => sum + item.cgstAmount, 0).toFixed(2);
                            filterDetails.igstAmount = gstSummary1List.reduce((sum, item) => sum + item.igstAmount, 0).toFixed(2);
                            this.setState({ filterDetails: filterDetails, gstPurchaseSummaryList: gstSummaryList, gstSummaryList: gstSummary1List }, () => {
                                this.getAllPartyDropdown()
                            })
                        })
                    } else {
                        this.setState({ tableStatus: "" })
                        this.SwalServices.Error(response.Message);
                        this.getAllPartyDropdown()
                    }
                });
            })
        }
    }


    getAllPartyDropdown = () => {
        this.commonServices.getAllPartyDropdown().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.partyName,
                    value: item._id,
                }));
                this.setState({ partyDropdownList: dropdownItems }

                );
            } else {

                this.SwalServices.Error(
                    response.Message
                );
            }
        });
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.filterDetails,
            this.state.validationRules,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };

    resetForm = () => {
        let validState = this.state.validState
        validState.error = {}
        validState.isValid = true
        let filterDetails = this.state.filterDetails
        filterDetails.startDate = ""
        filterDetails.endDate = ""
        filterDetails.allParty = true
        filterDetails.partyId = ""
        filterDetails.invoiceType = "allinvoice"
        filterDetails.gstRate = ""
        filterDetails.search = "invoiceDetails"
        filterDetails.salesAmount = ""
        filterDetails.discount = ""
        filterDetails.sgstAmt = ""
        filterDetails.cgstAmt = ""
        filterDetails.igstAmt = ""
        filterDetails.freight = ""
        filterDetails.other = ""
        filterDetails.roundOff = ""
        filterDetails.netAmount = ""
        filterDetails.taxableAmount = ""
        filterDetails.sgstAmount = ""
        filterDetails.cgstAmount = ""
        filterDetails.igstAmount = ""
        this.setState({ filterDetails: filterDetails, validState: validState, gstPurchaseRegisterList: [], gstSummaryList: [], gstPurchaseSummaryList: [] });
    };

    handleCheckbox = (e, name) => {
        let details = this.state.filterDetails;
        details[name] = !details.allParty;
        details["partyId"] = "";
        this.setState({ filterDetails: details });
    };
    handleChange = (event, name, section) => {
        let value = event.target.value;
        let details = this.state.filterDetails;
        details[name] = value.toUpperCase();
        this.setState({ filterDetails: details },
        );
    };
    setFilterParameters = (selected, drpIdentity, section) => {
        let details = this.state.filterDetails;
        details[drpIdentity] = selected.value;
        details["allParty"] = "";
        this.setState({ filterDetails: details });
    };

    handleDropDownChange = (event, name, section) => {
        const select = event.target.value;
        let details = this.state.filterDetails;
        details[name] = select;
        this.setState({ filterDetails: details });
    };

    render() {
        return (
            <div className='GstSalesRegister-page'>

                {/* Search section  */}
                <SearchSection
                    filterDetails={this.state.filterDetails}
                    handleChange={this.handleChange.bind(this)}
                    validState={this.state.validState}
                    partyDropdownList={this.state.partyDropdownList}
                    setFilterParameters={this.setFilterParameters.bind(this)}
                    handleCheckbox={this.handleCheckbox.bind(this)}
                    invoiceTypeList={this.state.invoiceTypeList}
                    handleDropDownChange={this.handleDropDownChange.bind(this)}
                    searchList={this.state.searchList}
                    getAllGstRegister={this.getAllGSTPurchaseRegister.bind(this)}
                    resetForm={this.resetForm.bind(this)}
                    totalCount={this.state.totalCount}
                    pageName={this.state.pageName}
                    materialTypeList={this.state.materialTypeList}

                />
                {/* Table Section  */}
                <TableSection
                    filterDetails={this.state.filterDetails}
                    gstSalesRegisterList={this.state.gstPurchaseRegisterList}
                    gstSalesSummaryList={this.state.gstPurchaseSummaryList}
                    gstSummaryList={this.state.gstSummaryList}
                    tableStatus={this.state.tableStatus}
                    companyName={this.state.companyName}
                />

                {/* Lower Function */}
                <LowerSection
                    filterDetails={this.state.filterDetails}
                />
            </div>
        );
    }
}

export default GstPurchaseRegister;